import $ from 'wee-dom';
import $events from 'wee-events';
import { _win } from 'core/variables';
import { RouteHandler } from 'wee-routes';

export default new RouteHandler({
    init() {
        const $select = $(':findAResearcher');

        if ($select) {
            $events.on($select, 'change', (e) => {
                const val = e.target.value;

                if (val) {
                    let url = `/providers/${val}`;

                    if (val === 'all') {
                        url = '/find-a-researcher';
                    }

                    _win.location = url;
                }
            });
        }
    },
});
